'use client';

import { Link } from '@/components/ui/Link';
import { HomeIcon } from '@heroicons/react/24/outline';
import { HomeIcon as HomeIconSolid } from '@heroicons/react/24/solid';
import { getEnvVar } from '@vimond/utils/env';

type Props = {
  categoryId: string;
};

export const CategoryButton = ({ categoryId }: Props) => {
  if (getEnvVar('NEXT_PUBLIC_CATEGORY_BUTTON_ENABLED') === 'false') return;

  return (
    <div className="group/{category} w-11">
      <Link href={`/category/${categoryId}`}>
        <HomeIconSolid className="hidden h-11 w-11 group-hover/{category}:block" />
        <HomeIcon className=" h-11 w-11 group-hover/{category}:hidden" />
      </Link>
    </div>
  );
};
